export default __webpack_public_path__ + "static/g-braden-b4e7d3fa51d8f57e9941ea257faae66c.jpg";